<div [ngClass]="[loaderSizeClass, loaderPositon]" class="dna-loader-container" id="loader">
  <div class="dna-loader-loop">
    <span class="loaderOverlay"></span>
    <div class="loader">Loading...</div>
  </div>
</div>
